import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSavingsGoalsinline = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 18 18",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.15,
			d: "M10.53 7.47 8.648 9.352"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.15,
			d: "M10.5 4.498V7.5h3.002l3.001-3-2-1.001-1.001-2.001z",
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.15,
			d: "M8.25 2.979a6.393 6.393 0 1 0 6.772 6.771"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.15,
			d: "M12.159 9.75a3.545 3.545 0 1 1-3.91-3.909"
		})
	]
});
export default SvgSavingsGoalsinline;
